"use client";

// IconCircle — the one round icon button for the whole app. A single circular
// control holding an icon: the standard for small actions (sign out) and on/off
// toggles (developer mode, admin column visibility). When `pressed` is provided
// it behaves as a toggle and lights with the living organism color; otherwise
// it's a plain action button. Styling lives in globals.css (.icon-circle).

import type { ButtonHTMLAttributes, ReactNode } from "react";

export default function IconCircle({
  children,
  pressed,
  size = "md",
  className,
  title,
  ...rest
}: {
  /** the icon (svg / glyph) */
  children: ReactNode;
  /** when defined, renders as a toggle (aria-pressed) and lights when true */
  pressed?: boolean;
  size?: "sm" | "md" | "lg";
  className?: string;
  title?: string;
} & Omit<ButtonHTMLAttributes<HTMLButtonElement>, "children">) {
  const sizeClass = size === "sm" ? " icon-circle--sm" : size === "lg" ? " icon-circle--lg" : "";
  return (
    <button
      type="button"
      title={title}
      aria-label={rest["aria-label"] ?? title}
      aria-pressed={pressed}
      className={["icon-circle" + sizeClass, className].filter(Boolean).join(" ")}
      {...rest}
    >
      {children}
    </button>
  );
}
